import { breakpoints } from '../helpers';
import scrollLock from 'scroll-lock';

const selectors = {
  mobileMenuOpen: '[data-mobile-menu-trigger]',
  mobileMenuClose: '[data-navigation-close]',
  mobileMenuOverlay: '[data-navigation-overlay]',
  navigationWrapper: '[data-navigation-wrapper]',
  megaNav: '[data-meganav]',
  megaNavOverlay: '[data-meganav-overlay]',
  navList: '[data-nav-list]',
  megaContent: '[data-mega-content]',
  megaSubTrigger: '[data-megamenu-sub-trigger]',
  megaSubContent: '[data-megamenu-sub-content]',
  megaBack: '[data-megamenu-back]',
  megaSubBack: '[data-megamenu-sub-back]',
  megaOverflowContainer: '[data-megamenu-overflow-container]',
  announcementBar: '[data-announcement-bar]',
};

const cssClasses = {
  hidden: 'hidden',
  transitionedIn: 'translate-x-full',
  transitionedOut: 'translate-x-0',
  navActive: 'main-nav-item--active',
};

export default class StaticHeader {
  constructor(section) {
    this.section = section;
    this.isDesktop = window.matchMedia(
      `(min-width: ${breakpoints.lg})`,
    ).matches;
    this.isMobile = window.matchMedia(`(max-width: ${breakpoints.lg})`).matches;

    this._initMegaNav();
    this._initMobileNav();
  }

  _initMobileNav = () => {
    this.navList = this.section.el.querySelector(selectors.navList);
    this.navigationWrapper = this.section.el.querySelector(
      selectors.navigationWrapper,
    );
    const mobileMenuOpen = this.section.el.querySelector(
      selectors.mobileMenuOpen,
    );
    if (mobileMenuOpen) {
      mobileMenuOpen.addEventListener('click', this._openMobileNav);
    }

    this.mobileMenuClose = this.section.el.querySelector(
      selectors.mobileMenuClose,
    );
    if (this.mobileMenuClose) {
      this.mobileMenuClose.addEventListener('click', this._closeMobileNav);
    }

    this.mobileMenuOverlay = this.section.el.querySelector(
      selectors.mobileMenuOverlay,
    );

    if (this.mobileMenuOverlay) {
      this.mobileMenuOverlay.addEventListener('click', this._closeMobileNav);
    }
  };

  _openMobileNav = () => {
    this.mobileMenuOverlay.classList.add('flex');
    this.mobileMenuOverlay.classList.remove(cssClasses.hidden);
    this.navigationWrapper.classList.remove(cssClasses.transitionedOut);
    this.navigationWrapper.classList.add(cssClasses.transitionedIn);
    scrollLock.disablePageScroll();
  };

  _closeMobileNav = () => {
    this.mobileMenuOverlay.classList.remove('flex');
    this.mobileMenuOverlay.classList.add(cssClasses.hidden);
    this.navigationWrapper.classList.remove(cssClasses.transitionedIn);
    this.navigationWrapper.classList.add(cssClasses.transitionedOut);
    scrollLock.enablePageScroll();
    this._closeAllMegaNavs();
  };

  _initMegaNav = () => {
    this.announcementBar = document.querySelector(selectors.announcementBar);
    if (this.announcementBar) {
      this.announcementBar.addEventListener(
        'mouseover',
        this._closeAllMegaNavs,
      );
    }
    this.megaNavs = this.section.el.querySelectorAll(selectors.megaNav);
    this.megaNavs.forEach(nav => {
      let mouseEvent;
      if (this.isDesktop) {
        mouseEvent = 'mouseover';
      } else {
        mouseEvent = 'click';
      }
      nav.addEventListener(mouseEvent, e => {
        if (!e.target.classList.contains(cssClasses.navActive)) {
          const openedNav = this._closeAllMegaNavs();
          const clickedNav = e.target.getAttribute('data-meganav');

          if (clickedNav !== openedNav) {
            this._openMegaNav(clickedNav);
            e.target.classList.add(cssClasses.navActive);
          }
        }
      });
    });

    const megaNavOverlay = this.section.el.querySelectorAll(
      selectors.megaNavOverlay,
    );
    megaNavOverlay.forEach(overlay => {
      let mouseEvent;
      if (this.isDesktop) {
        mouseEvent = 'mouseover';
      } else {
        mouseEvent = 'click';
      }
      overlay.addEventListener(mouseEvent, () => {
        this._closeAllMegaNavs();
      });
    });

    const megaSubTriggers = this.section.el.querySelectorAll(
      selectors.megaSubTrigger,
    );
    megaSubTriggers.forEach(subTrigger => {
      subTrigger.addEventListener('click', e => {
        if (this.isMobile) {
          e.preventDefault();
          const subContent = subTrigger.parentNode.querySelector(
            selectors.megaSubContent,
          );
          subContent.classList.remove(cssClasses.hidden);
        }
      });
    });

    const megaSubBack = this.section.el.querySelectorAll(selectors.megaSubBack);
    megaSubBack.forEach(subBack => {
      subBack.addEventListener('click', () => {
        if (this.isMobile) {
          if (subBack.hasAttribute('data-megamenu-sub-single')) {
            this._closeAllMegaNavs();
          } else {
            this._closeAllSubMegaNavs();
          }
        }
      });
    });

    const megaBack = this.section.el.querySelectorAll(selectors.megaBack);
    megaBack.forEach(back => {
      back.addEventListener('click', () => {
        if (this.isMobile) {
          this._closeAllMegaNavs();
        }
      });
    });
  };

  _openMegaNav = navItem => {
    const selectedNav = document.getElementById(`${navItem}-meganav`);
    selectedNav.classList.remove(cssClasses.hidden);
    if (this.isDesktop) {
      const headerHeight = this.section.el.offsetHeight;
      const announcementBarHeight = this.announcementBar.offsetHeight;
      const totalHeaderHeight = headerHeight + announcementBarHeight;
      const overflowContainer = selectedNav.querySelector(
        selectors.megaOverflowContainer,
      );
      overflowContainer.style.maxHeight = `calc(96vh - ${totalHeaderHeight}px)`;

      this.clickOffFunc = e => {
        if (!selectedNav.contains(e.target)) {
          this._closeAllMegaNavs();
        }
      };

      // Close nav if clicking anywhere on header
      this.section.el.addEventListener('click', this.clickOffFunc);
      scrollLock.disablePageScroll();
    }
  };

  _closeAllMegaNavs = () => {
    if (this.isDesktop) {
      this.section.el.removeEventListener('click', this.clickOffFunc);
      scrollLock.enablePageScroll();
    }
    let currentlyOpenNav = null;
    this.megaNavs.forEach(nav => {
      const navItem = nav.getAttribute('data-meganav');
      nav.classList.remove(cssClasses.navActive);
      const selectedNav = document.getElementById(`${navItem}-meganav`);
      if (!selectedNav.classList.contains(cssClasses.hidden)) {
        currentlyOpenNav = navItem;
      }
      selectedNav.classList.add(cssClasses.hidden);
    });
    return currentlyOpenNav;
  };

  _closeAllSubMegaNavs = () => {
    const megaSubContent = this.section.el.querySelectorAll(
      selectors.megaSubContent,
    );
    megaSubContent.forEach(nav => {
      if (!nav.hasAttribute('data-megamenu-sub-single')) {
        nav.classList.add(cssClasses.hidden);
      }
    });
  };
}
